import {questionTypes} from "@modules/AudienceManager/Util";

import ChecklistQuestion from './ChecklistQuestion/ChecklistQuestion.vue';
import MultiSelectFilterQuestion from './MultiSelectFilterQuestion/MultiSelectFilterQuestion.vue';
import SelectQuestion from './SelectQuestion/SelectQuestion.vue';
import RangeSliderQuestion from './RangeSliderQuestion/RangeSliderQuestion.vue';
import RadiolistQuestion from './RadiolistQuestion/RadiolistQuestion.vue';


/**
 * Create an object binding vue components to our question types
 * @returns {Object.<string, Object>} Mapping
 */
const createBindings = () => ({
    [questionTypes.Checklist]: ChecklistQuestion,
    [questionTypes.MultiSelectFilter]: MultiSelectFilterQuestion,
    [questionTypes.Select]: SelectQuestion,
    [questionTypes.RangeSlider]: RangeSliderQuestion,
    [questionTypes.Radiolist]: RadiolistQuestion
});


export {
    createBindings
};

export default createBindings();